function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

export default function() {
  return this.each(lower);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/lower.js
// module id = 403
// module chunks = 0 1 2 3 4